import { useQueries } from "@tanstack/react-query";
import round from "lodash/round";
import {
  Clock,
  Percent,
  Phone,
  PhoneIncoming,
  Target,
  TrendingUp,
} from "lucide-react";

import { CallDashboardMetric } from "routes/dashboard/CallDashboardMetric";
import { useCallDashboardFilters } from "routes/dashboard/useCallDashboardFilters";
import DashboardService from "services/Dashboard";

const STATS = ["dials", "pickups", "hours", "leads", "days"];

function CallDashboardSummaryStats() {
  const [queryFilters] = useCallDashboardFilters();
  const results = useQueries({
    queries: STATS.map(stat => ({
      queryKey: ["dashboard", "calls-summary", stat, queryFilters],
      queryFn: () =>
        DashboardService.getCallsSummary(stat, queryFilters).then(
          r => r.count ?? 0
        ),
    })),
  });
  const [dials, pickups, hours, leads, days] = results;

  return (
    <div className="tw:mb-4 tw:flex tw:flex-wrap tw:gap-3">
      <CallDashboardMetric
        icon={Phone}
        label="Dials Made"
        value={dials.data}
        isLoading={dials.isFetching}
      />
      <CallDashboardMetric
        icon={PhoneIncoming}
        label="Pickups"
        value={pickups.data}
        isLoading={pickups.isFetching}
      />
      <CallDashboardMetric
        icon={Percent}
        label="Pickup Rate"
        value={round((pickups.data / dials.data) * 100, 2) || 0}
        isLoading={pickups.isFetching || dials.isFetching}
        formatValue={v => `${v}%`}
      />
      <CallDashboardMetric
        icon={Clock}
        label="Hours Called"
        value={hours.data}
        isLoading={hours.isFetching}
      />
      <CallDashboardMetric
        icon={TrendingUp}
        label="Avg Dials/Day"
        value={round(dials.data / days.data, 2) || 0}
        isLoading={dials.isFetching || days.isFetching}
      />
      <CallDashboardMetric
        icon={Target}
        label="Leads"
        value={leads.data}
        isLoading={leads.isFetching}
      />
    </div>
  );
}

export default CallDashboardSummaryStats;
